// #region Dependencias
import { useDispatch, useSelector } from 'react-redux'
import { loginRequest } from 'store/thunks/authThunk'
import useImprovedForm from 'hooks/useImprovedForm'
import { Button, Card, CardBody, CardFooter, CardHeader, Form, Input } from 'components/Library'
import { colors } from 'components/Library/theme'
import Dialog from 'components/Popups/Dialog'
// #endregion

/**
 * Vista que renderiza la pagina de autenticación.
 * @class
 * @module Auth
 */
const Login = () => {
  const dispatch = useDispatch()
  const { cargando } = useSelector((state) => state.auth)
  const [formValues, , handleInputChange] = useImprovedForm({
    correo: '',
    clave: ''
  })

  const errors = {}

  /**
   * Función para manejar el envío del formulario de inicio de sesión mediante
   * la función {@link loginRequest}.
   * @param {Event} e - Evento de envío del formulario.
   */
  const handleLoginSubmit = (e) => {
    e.preventDefault()
    dispatch(loginRequest(formValues))
  }

  return (
    <>
      <Dialog borderradius={2} color={colors.primary} />
      <Card
        style={{
          margin: '2rem auto',
          width: '95%'
        }}
      >
        <Form onSubmit={handleLoginSubmit}>
          <CardHeader color="primary">GuanabanApp</CardHeader>
          <CardBody>
            <Input
              label="Correo electrónico"
              name="correo"
              helper="Correo electrónico"
              disabled={cargando}
              onChange={handleInputChange}
              value={formValues.correo}
              error={errors.correo}
            />
            <Input
              label="Contraseña"
              name="clave"
              type="password"
              helper="Contraseña de usuario"
              disabled={cargando}
              onChange={handleInputChange}
              value={formValues.clave}
              error={errors.clave}
            />
          </CardBody>
          <CardFooter>
            <Button
              borderradius="2"
              color="primary"
              disabled={cargando}
              text="Iniciar sesión"
              type="submit"
            />
          </CardFooter>
        </Form>
      </Card>
    </>
  )
}

export default Login
